export interface Shelter {
  id: string;
  name: string;
  city: string;
  region: string | null;
  address: string | null;
  postal_code: string | null;
  lat: number;
  lng: number;
  phone: string | null;
  email: string | null;
  website: string | null;
  current_needs: string | null;
  urgent_needs: boolean | null;
  urgent_needs_set_at: string | null;
  dog_walking_available: boolean | null;
  volunteering_available: boolean | null;
  dogs_available: boolean | null;
  cats_available: boolean | null;
  volunteer_info: string | null;
  description: string | null;
  last_updated: string;
  created_at: string;
  data_verified: boolean;
  organization_verified: boolean;
  organization_verified_at: string | null;
  organization_verification_pending: boolean;
  organization_verification_requested_at: string | null;
  contacted: boolean;
}

// Check if urgent needs is active (not expired after 1 month)
export const isUrgentNeedsActive = (shelter: Shelter): boolean => {
  if (!shelter.urgent_needs) return false;
  if (!shelter.urgent_needs_set_at) return true; // Fallback for old data
  
  const setAt = new Date(shelter.urgent_needs_set_at);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  
  return setAt > oneMonthAgo;
};

export interface ShelterFilters {
  searchQuery: string;
  dogWalking: boolean;
  volunteering: boolean;
  urgentNeeds: boolean;
  dogsAvailable: boolean;
  catsAvailable: boolean;
  organizationVerified: boolean;
  city: string;
}
